import React,{ Component } from 'react';
import NavLink             from '../generic/nav-link';
import { Link }            from 'react-router';

let logoSrc = require('../../../img/freshbytes-logo.png');

export default class NavBar extends Component {

    constructor(props, isGrayNav) {
        super(props);
        this.state = {
            isGrayNav
        };
    }

    render() {
        let style = this.state.isGrayNav ? 'show-overlay' : '';

        return (
            <nav className="navbar navbar-fixed-top">
              <div className="container-fluid navbar-pg" style={{marginLeft : 60, marginRight : 60}}>
                <div className="navbar-header">
                  <a className="navbar-brand" href="http://freshbytes.io/" aria-label="navbar-logo">
                      <img style={{width : 110}} src={logoSrc} alt=""/>
                  </a>
                </div>
                <div id="navbar">
                  <ul className="nav navbar-nav navbar-right pull-right">
                      <li className="sliding-middle-out" style={{paddingRight:15}}>
                          <a  href="tel:8889637374" className={"forgot-pass-text"}>(888)-96-37374</a>
                          <span className={"pull-right forgot-pass-text"} >Let's Talk</span>
                      </li>
                  </ul>
              </div>{/*<!--/.nav-collapse -->*/}
              </div>
              <div id="nav-overlay" className={"nav-scroll-overlay "+style}></div>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// src/components/layout/navbar.js